import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['status', 'index', 'locationIndex', 'type']);
  const createBusinessUnit = `createBusinessUnit(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createBusinessUnit} {
      id
    }
  }
`;
};
